import { StrictMode } from 'react'
import { hydrateRoot, createRoot } from 'react-dom/client'
import App from './App'
import './styles.css'

// Initialize i18n
import './lib/i18n/index.ts'

const rootElement = document.getElementById('root')
if (!rootElement) {
  throw new Error('Root element not found')
}

// Use createRoot in dev if SSR outlet is empty, hydrateRoot otherwise
if (rootElement.innerHTML.trim() && rootElement.innerHTML.trim() !== '<!--ssr-outlet-->') {
  hydrateRoot(
    rootElement,
    <StrictMode>
      <App />
    </StrictMode>
  )
} else {
  createRoot(rootElement).render(
    <StrictMode>
      <App />
    </StrictMode>
  )
}
